import { Component, Input } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EmailFormComponent } from '../../../../base/shared/email-form/email-form.component';
import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';
import { OutputEmailAccountsService } from '../../activation-email-templates/output-email-accounts.service';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-email-template-form',
    templateUrl: './email-template-form.component.html',
    styleUrls: ['./email-template-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, EmailFormComponent, TranslateModule, DropDownListModule]
})
export class EmailTemplateFormComponent {

  @Input()
  public emailTemplateForm: UntypedFormGroup;

  public outputEmailAccountFields = { text: 'accountName', value: 'id' };

  public get outputEmailAccounts() {
    return this.outEmailAccountsService.outputEmailAccounts;
  }

  constructor(private outEmailAccountsService: OutputEmailAccountsService) { }
}
